import { Directive, Input, OnChanges } from '@angular/core';
import {
  NG_VALIDATORS,
  UntypedFormControl,
  Validators,
  Validator
} from '@angular/forms';
import { isEqual } from 'lodash';

@Directive({
  selector: '[fieldMatch][ngModel]',
  providers: [
    { provide: NG_VALIDATORS,
useExisting: FieldMatchValidator,
multi: true }
  ]
})
// validator works as follows:
// it is declared on both related fields, on one field it is declared with 'reverse=true'.
// examples of declarations:
// <input name="pwd" #pwdInput="ngModel" [fieldMatch]='repeatPwdInput.control' [reverse]='true' />
// <input name="repeatPwd" #repeatPwdInput="ngModel" [fieldMatch]='pwdInput.control' />
// this way they get aware of each other and can show/hide errors if passwords start to mismatch
export class FieldMatchValidator implements OnChanges, Validator {
  @Input('fieldMatch')
  key: UntypedFormControl; // the 'other' field
  @Input('reverse')
  reverse: boolean;

  validatorFn: any = Validators.nullValidator;
  constructor() {}

  ngOnChanges(): void {
    if (this.key) {
      this.validatorFn = this.configureValidator(this.key);
    } else {
      this.validatorFn = Validators.nullValidator;
    }
  }

  configureValidator(otherControl: UntypedFormControl) {
    return (currentControl: UntypedFormControl) => {
      if (!currentControl || !otherControl) {
        return null; // too early to validate anything
      }
      const otherFieldInput = otherControl.value;
      const currentFieldInput = currentControl.value;

      if (!isEqual(otherFieldInput, currentFieldInput)) {
        if (this.reverse) {
          otherControl.setErrors({ fieldMatch: 'bad' });
        } else {
          return { fieldMatch: 'bad' };
        }
      } else {
        if (this.reverse) {
          otherControl.setErrors(null);
        }
      }
      return null;
    };
  }

  validate(control: UntypedFormControl) {
    return this.validatorFn(control);
  }
}
